import * as api from "./apis/sendAppMfaCode";
import { triggerError } from "../utils/eventManager";
import { sendNewRelicEvent } from "../utils/newRelicEvents";
import { Mfa_Status } from "../__generated__/auth-gate";
export { sendAppMfaCode };
async function sendAppMfaCode(mfaToken, userUuid) {
  try {
    var response = await api.sendAppMfaCode(mfaToken, userUuid);
    if (response.status === Mfa_Status.ONBOARDING) {
      /* istanbul ignore next */
      return response;
    }
    return response;
  } catch (e) {
    sendNewRelicEvent({
      EventName: 'send_app_mfa_code_failed',
      error: e
    });
    triggerError('send app mfa code', e);
    throw e;
  }
}